import classNames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { useTheme, useThemeClassName } from '../../contexts/ThemeContext';
import Logo from '../icons/Logo';
import QRCode from '../icons/QRCode';

import styles from '../../../styles/steps/start.module.scss';

const propTypes = {
    game: PropTypes.shape({}),
    step: PropTypes.shape({}),
    isDisplay: PropTypes.bool,
    vertical: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    game: null,
    step: null,
    isDisplay: false,
    vertical: null,
    className: null,
};

function Start({ step, isDisplay, vertical, className }) {
    const { name: theme = null } = useTheme();
    const themeClassName = useThemeClassName(styles);
    const { title = null } = step || {};

    return (
        <div
            className={classNames([
                styles.container,
                themeClassName,
                {
                    [styles.isDisplay]: isDisplay,
                    [styles.vertical]: vertical === true,
                    [styles.horizontal]: vertical === false,
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.inner}>
                <Logo className={styles.logo} component="defis-vertical" />
                {title !== null ? <h3 className={styles.title}>{title}</h3> : null}
                <div className={styles.qrcodeContainer}>
                    <p className={styles.description}>
                        <FormattedMessage
                            defaultMessage="Scan the QR code to enter."
                            description="Display message"
                        />
                    </p>
                    <QRCode className={styles.qrcode} component={theme} />
                </div>
                <div className={styles.footer} />
            </div>
        </div>
    );
}

Start.propTypes = propTypes;
Start.defaultProps = defaultProps;

export default Start;
